import { getSearchSuggestionOptionId } from './get-search-suggestion-option-id';

export const getSearchActiveDescendantId = (navigationIndex: number) =>
  navigationIndex >= 0 ? getSearchSuggestionOptionId(navigationIndex) : undefined;
